import type { GiftFields } from "@jti/store/utils";

import { sortByStandaloneGifts } from "@commerce/shared";

export const sortByGifts = (a: GiftFields, b: GiftFields) => {
  return a.isGift === b.isGift ? sortByStandaloneGifts(a, b) : a.isGift ? 1 : -1;
};
